import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const generatePreviewHtml = payload =>
  api.post('/platform/temp-common/html-replace-url', payload.data, { params: payload.params })

export default {
  generatePreviewHtml,
}
